// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2HcMJ","content":"LoadingAlert_content__3XkIA"};